define('app/views/dc_lasts_item_view',['app/setup', 'app/session'],
  function (takhfifan, session) {

    takhfifan.DiscountLastsItemView = Backbone.View.extend({

      events: {
        'click .tkh-latest-dc-item__buy-btn': 'submit',
      },

      initialize: function (options) {
        var data = this.$el.data("productData");
        var _this = this;
        this.model = new takhfifan.Discount();
        this.model.parse(data, null);
        this.model.formKey = takhfifan.formKey;

        this.isLimited = this.model.get('maxPerOrder') < 10;
        this.checkUrl = options.checkUrl;
        this.$buyBtn = this.$el.find('.tkh-latest-dc-item__buy-btn');

        takhfifan.eventHub.on('dc:checkoutProcess' + this.model.id, function(pid) {
          _this.checkoutProcess();
        });

        takhfifan.eventHub.on('buyButton:soldOut', function () {
          _this.$buyBtn.disable();
        });

        this.generateAddToCartForm();
      },

      generateAddToCartForm: function () {
        var $form = $('<form />').prop({
          method: 'post',
          action: '#'
        }).css('display', 'none');

        this.$el.append($form);
        new takhfifan.AddToCartFormView({el: $form, productId: this.model.id});

        if (!_.isUndefined(this.model.get('seconds'))) {
          takhfifan.eventHub.trigger('cartinfo:' + this.model.get('id'), this.model);

          if (this.model.get('isSoldOut')) {
            takhfifan.eventHub.trigger('buyButton:soldOut', this.model);
          }
        }
      },

      submit: function (event) {
        event.preventDefault();
        if (this.isLimited) {
          this.customer = session.getCustomerVerificationData();
          if (this.customer && this.customer.verified) {
            this.checkoutProcess();
          } else {
            takhfifan.eventHub.trigger(
              'dc:verifyPhoneNumber',
              {pid: this.model.id, phoneNumber: this.customer.number});
          }
        } else {
          this.checkoutProcess();
        }
      },

      showFreeSingleCode: function(checkoutType, viewObject){
        var _this = viewObject;
        if(session.customerIsLoggedIn()){
          this.model.buyFreeSingleCoupon(_this.model.id, session.getCustomerData().email,
            function (data) {
              if(data && data.success){
                _this.showMultiUseCodeModal(data.code);
                takhfifan.eventHub.trigger('dc:getDiscount',
                  {productID: _this.model.id, vendorId: _this.model.get('vendorId')});
              }else{
                takhfifan.eventHub.trigger('message:show', {
                  type: 'error',
                  msg: data.error
                });
              }
            });
        }else{
          takhfifan.eventHub.trigger('customer:loginForm');
        }
      },

      checkoutProcess: function () {
        this.$el.addClass('loading-view');
        var _this = this;
        this.model.getCheckoutType(takhfifan.formKey, this.checkUrl, function (checkoutType) {
          if (checkoutType.success) {
            if (checkoutType.type === 'cart') {
              takhfifan.eventHub.trigger(
                'dc:conditionalModal',
                {
                  pid: _this.model.id,
                  vendorId: _this.model.get('vendorId'),
                  itemViewObj: _this,
                  title:_this.model.get('name'),
                  highlight: _this.model.get('dealHighlights')
                });
            }else if (checkoutType.type === 'free') {
              _this.showFreeSingleCode(checkoutType, _this);
            } else {
              _this.showMultiUseCodeModal(checkoutType.code);
              takhfifan.eventHub.trigger('dc:getDiscount',
                {productID: _this.model.id, vendorId: _this.model.get('vendorId')});
            }
          } else {
            takhfifan.eventHub.trigger('modal:closeModalWithContent');
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: checkoutType.error
            });
          }
          _this.$el.removeClass('loading-view');
        });
      },

      showMultiUseCodeModal: function (code) {
        takhfifan.eventHub.trigger('modal:closeModalWithContent');
        takhfifan.eventHub.trigger('dc:multiUseModal', {
          pid: this.model.id,
          vendorId: this.model.get('vendorId'),
          partnerURL: this.model.get('partnerUrl'),
          title: this.model.get('name'),
          highlight: this.model.get('dealHighlights'),
          condition: this.model.get('dealCondition'),
          code: code,
        });
      }

    });
  });
